module.exports = __webpack_public_path__ + "static/frame-9-fec594d5d086d9c40e23f538b8dfda2a.png";